import { render, staticRenderFns } from "./Monitoringserver copy 2.vue?vue&type=template&id=fc967d40&scoped=true"
import script from "./Monitoringserver copy 2.vue?vue&type=script&lang=js"
export * from "./Monitoringserver copy 2.vue?vue&type=script&lang=js"
import style0 from "./Monitoringserver copy 2.vue?vue&type=style&index=0&id=fc967d40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc967d40",
  null
  
)

export default component.exports